import {Component, Vue} from 'vue-property-decorator';
import SearchModal from '@/components/SearchModal.vue';
import {
    AddressResults,
    SelectedLocation,
    SelectedServiceProduct,
    Service,
    ShoppingCartData
} from '@/products-and-services/ProductsAndServicesModels';

@Component({
    components: {
        SearchModal
    }
})
export default class SearchMixin extends Vue {
    protected showAddressModal = false;
    protected showLocationError = false;

    openAddressSearch() {
        this.showAddressModal = true;
    }

    closeAddressSearch() {
        this.showAddressModal = false;
    }

    closeLocationError(){
        this.showLocationError = false;
        this.$store.commit('clearStoredItem');
        sessionStorage.removeItem('currentAddress');
    }

    async addressSelected(address: AddressResults, queryLogId: string) {
        try {
            await this.$store.commit('setQueryLogId', queryLogId);
            this.showAddressModal = false;
            const { serviceAddress, regionId } = this.$store.state.shoppingCartData as ShoppingCartData;
            await this.$store.dispatch('updateOrderDetails', {
                mutation: 'updateCartServiceLocation', item: {
                    addressId: address.addressId,
                    location: address.serviceAddress,
                    serviceAddress: address.serviceAddress,
                    serviceUnit: address.unit,
                    serviceCity: address.city,
                    regionId: address.regionId
                } as SelectedLocation
            });
            const {serviceId, serviceTypeId} = (this.$store.getters.getStoredItem() || {}) as SelectedServiceProduct;
            // remove  && address.regionId !== '5' when ACAM region 5 is turned back on, just two changes here and ProductsAndServices.ts
            if (serviceId && serviceTypeId && this.$store.state.shoppingCartData.hasActiveFiber) {
                const {catId: serviceCatId} = (this.$store.getters.getServiceByTypeIdAndId(serviceTypeId, serviceId, true) || {}) as Service;
                if (serviceCatId) {
                    await this.$store.dispatch('updateOrderDetails', { mutation: 'addToCart', item: { serviceTypeId, serviceId, serviceCatId } });
                    this.$store.commit('clearStoredItem');
                    sessionStorage.removeItem('currentAddress');
                } else {
                    this.showLocationError = true;
                }
            }
            
            var result = {
                addressId: address.addressId,
                serviceAddress: address.serviceAddress,
                unit: address.unit,
                city: address.city,
                cityDescription: address.cityDescription, 
                zipCode: address.zipCode,
                regionId: address.regionId,
                serviceState: 'ND' // its not stored in db, its just hardcoded in the api queries
           };
    
           var parameters = {
                result: result, 
                queryLogId:  queryLogId
           };
           
           sessionStorage.setItem("currentAddress", JSON.stringify(parameters));
        }
        catch (error) {
            this.$notifyError(error);
        }
    }
}
